import { render, staticRenderFns } from "./dictationtools.vue?vue&type=template&id=739fc944&scoped=true&"
import script from "./dictationtools.vue?vue&type=script&lang=js&"
export * from "./dictationtools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739fc944",
  null
  
)

export default component.exports